import { CommonModule } from "@angular/common";
import { ChangeDetectionStrategy, Component, EventEmitter, HostBinding, input, Output } from "@angular/core";
import { IIconComponent } from "@front/m19-ui";

@Component({
  selector: "app-strategy-info-bloc",
  imports: [CommonModule, IIconComponent],
  templateUrl: "./strategy-info-bloc.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StrategyInfoBlocComponent {
  disabled = input(false);
  testid = input<string | undefined>(undefined);

  @Output() strategyInfoClick = new EventEmitter<void>();

  @HostBinding("class") classes = "inline-block";

  onClickHandler() {
    if (!this.disabled()) {
      this.strategyInfoClick.emit();
    }
  }
}
